

import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import { DevicesModule } from '~/store/modules/devices';

@Component({
    components: {

    }
})
export default class OperationGetLocalResourcesPopup extends Mixins(PopupMixin) {
    get currentGatewayId() {
        return DevicesModule.currentGatewayId;
    }

    get localResources() {
        return DevicesModule.localResources;
    }
}
